import { apiClient } from './client'

export async function getVersion(): Promise<string> {
  const { data } = await apiClient.get<{ version: string }>('/api/version')
  return data.version
}
